import React from 'react';
import { EyeOff } from 'lucide-react';

// Marks admin fields that the app never shows to users and that no rule reads,
// so admins don't spend time filling them in.
const InternalOnlyHint = ({ title = 'Yalnızca admin panelinde görünür; uygulamada kullanıcıya gösterilmez.' }) => (
  <span
    title={title}
    className="inline-flex items-center gap-1 rounded bg-gray-100 px-1.5 py-0.5 text-[10px] font-medium text-gray-500 whitespace-nowrap"
  >
    <EyeOff className="h-3 w-3" />
    Kullanıcıya görünmez
  </span>
);

export default InternalOnlyHint;
